import React from 'react';
import { Instagram, Twitter, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 px-6 bg-black">
      <div className="container mx-auto max-w-5xl">
        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <h2 className="text-4xl font-light text-white mb-6 uppercase tracking-tight">Connect</h2>
            <p className="text-zinc-400 font-light mb-12 max-w-md">
              Ready to elevate your next project? Reach out to discuss management, production, or event inquiries.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-center gap-4 text-zinc-300">
                <Mail className="text-white" size={20} />
                <span>manifestentertainmentindia@gmail.com</span>
              </div>
              <div className="flex items-center gap-4 text-zinc-300">
                <Instagram className="text-white" size={20} />
                <span>@manifestentertainment.india</span>
              </div>
              <div className="flex items-center gap-4 text-zinc-300">
                <Twitter className="text-white" size={20} />
                <span>@manifestentertainment.india</span>
              </div>
            </div>
          </div>

          <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="text-xs uppercase tracking-widest text-zinc-500">First Name</label>
                <input type="text" className="w-full bg-zinc-900 border border-zinc-800 p-4 text-white focus:outline-none focus:border-white transition-colors" />
              </div>
              <div className="space-y-2">
                <label className="text-xs uppercase tracking-widest text-zinc-500">Last Name</label>
                <input type="text" className="w-full bg-zinc-900 border border-zinc-800 p-4 text-white focus:outline-none focus:border-white transition-colors" />
              </div>
            </div>
            <div className="space-y-2">
              <label className="text-xs uppercase tracking-widest text-zinc-500">Email</label>
              <input type="email" className="w-full bg-zinc-900 border border-zinc-800 p-4 text-white focus:outline-none focus:border-white transition-colors" />
            </div>
            <div className="space-y-2">
              <label className="text-xs uppercase tracking-widest text-zinc-500">Message</label>
              <textarea rows="4" className="w-full bg-zinc-900 border border-zinc-800 p-4 text-white focus:outline-none focus:border-white transition-colors"></textarea>
            </div>
            <button className="w-full bg-white text-black font-bold uppercase tracking-widest py-4 hover:bg-zinc-200 transition-colors">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
